var _defs, _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWazeAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);}.cls-2{fill:#fff;}.cls-2,.cls-3,.cls-4{fill-rule:evenodd;}.cls-4{fill:#3cf;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 10.44,
    y: 10.43,
    width: 31.07,
    height: 31.17,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    className: "cls-2",
    d: "M10.44,10.43h31.06v31.17H10.44V10.43Z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    className: "cls-4",
    d: "M52,8.56v34.89c0,4.73-3.83,8.56-8.56,8.56H8.56C3.83,52,0,48.17,0,43.44V8.56C0,3.83,3.83,0,8.56,0h34.89c4.73,0,8.56,3.83,8.56,8.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.54,36.94h-3.17c-.36-1.82-1.95-3.13-3.8-3.13-1.32,0-2.56.66-3.27,1.78v.03c-1.16-.6-2.22-1.39-3.14-2.32-1.09-1.11-1.69-2.12-1.96-2.76.71-.17,1.36-.55,1.86-1.08.67-.72,1.04-1.68,1.04-2.66v-2.32c0-2.76.92-5.46,2.61-7.63,2.42-3.11,5.99-4.85,9.84-4.85,3.31,0,6.42,1.3,8.77,3.66,2.34,2.33,3.65,5.5,3.64,8.81,0,3.33-1.29,6.46-3.64,8.81-2.29,2.3-5.43,3.68-8.78,3.68"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.54,36.94h-3.17c-.36-1.82-1.95-3.13-3.8-3.13-1.32,0-2.56.66-3.27,1.78v.02c-1.16-.6-2.22-1.39-3.14-2.32-1.09-1.11-1.69-2.12-1.96-2.76.71-.17,1.36-.55,1.86-1.08.67-.72,1.04-1.68,1.04-2.66v-2.32c0-2.76.92-5.46,2.61-7.63,2.42-3.11,5.99-4.85,9.84-4.85,3.31,0,6.43,1.3,8.77,3.66,2.34,2.33,3.65,5.5,3.64,8.81,0,3.33-1.29,6.46-3.64,8.81-2.29,2.3-5.43,3.68-8.78,3.68M41.51,24.45c0-3.72-1.47-7.28-4.1-9.9-2.64-2.65-6.15-4.11-9.87-4.11-4.27,0-8.24,1.91-10.96,5.32-1.96,2.48-3.03,5.55-3.03,8.71v2.33c0,1.18-.93,2.35-2.5,2.35-.26,0-.49.17-.57.42-.29.97.89,3.12,2.57,4.82,1.07,1.09,2.31,1.98,3.67,2.66-.37,2.12,1.05,4.13,3.16,4.5.22.04.44.06.66.06,1.85,0,3.45-1.3,3.81-3.12h3.26c.43,2.2,2.72,3.71,5.16,2.89,1.06-.36,1.91-1.19,2.28-2.25.36-1.02.31-2-.02-2.85.86-.55,1.65-1.19,2.37-1.92,2.63-2.63,4.1-6.19,4.09-9.91"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.3,21.34c0-.86-.69-1.56-1.55-1.56s-1.55.7-1.55,1.56.7,1.56,1.55,1.56,1.55-.7,1.55-1.56M25.98,21.34c0-.86-.69-1.56-1.55-1.56s-1.55.7-1.55,1.56.7,1.56,1.55,1.56,1.55-.7,1.55-1.56M24.9,26.44c-.13-.27-.41-.44-.71-.44-.43,0-.77.35-.78.77,0,.11.02.22.07.33,1.02,2.18,3.21,3.57,5.62,3.58,2.41,0,4.6-1.4,5.62-3.58.18-.39.01-.85-.38-1.03-.1-.05-.21-.07-.33-.07h-.02c-.3,0-.56.17-.69.44-.77,1.63-2.41,2.67-4.21,2.67-1.8,0-3.44-1.05-4.21-2.68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWazeAppIcon);
export default __webpack_public_path__ + "static/media/waze-app-icon.1ae2e5f8d24bc6f3cdc891600ce35e8b.svg";
export { ForwardRef as ReactComponent };